import { render } from "./InfoView.vue?vue&type=template&id=75886521&scoped=true"
const script = {}

import "./InfoView.vue?vue&type=style&index=0&id=75886521&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75886521"]])

export default __exports__